import { useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Box, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { getLocalizedContent as l } from '@helpers';
import { LeadCollectionContext } from '@hooks/useLeadCollection';
import colors from '@theme/colors';
import content from './LeadCollectionPage.translation.json';
import { VEHICLE_VARIANT } from '@constants/vehicleVariant';
const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'GT America',
    fontSize: '20px',
    lineHeight: '24px',
    fontWeignt: 400,
    color: colors['charcoal'],
    paddingTop: '30px',
    paddingBottom: '30px',
  },
  formLabel: {
    textTransform: 'uppercase',
    fontWeight: '500',
    fontSize: '12px',
    color: colors['charcoal'],
    lineHeight: '16px',
    paddingTop: '30px',
    paddingBottom: '10px',
  },
  subContent: {
    fontFamily: 'GT America',
    fontSize: '16px',
    color: colors['charcoal'],
    lineHeight: '19px',
    fontWeight: '400',
  },
}));

export const LeadCollectionConfirmationTemplate = () => {
  const { leadCollectionResponse } = useContext(LeadCollectionContext);
  const { prefixLanguage: language } = useSelector(({ appState }) => appState);
  const styles = useStyles();
  return (
    <Box style={{ paddingBottom: '20px' }}>
      <Typography className={styles.formLabel}>
        {leadCollectionResponse.eventDate}
      </Typography>
      <Typography className={styles.formLabel}>
        {l(content.personalInfoTitle, language)}
      </Typography>
      <Typography className={styles.subContent}>
        {leadCollectionResponse.firstName} {leadCollectionResponse.lastName}
      </Typography>
      <Typography className={styles.subContent}>
        {leadCollectionResponse.email}
      </Typography>
      <Typography className={styles.subContent}>
        {leadCollectionResponse.phoneNumber}
      </Typography>

      <Typography className={styles.formLabel}>Interested in</Typography>
      {leadCollectionResponse.vehiclesInterested?.map(variant => (
        <Typography key={variant} className={styles.subContent}>
          {VEHICLE_VARIANT[variant]}
        </Typography>
      ))}
    </Box>
  );
};
